"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const shinehair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-shinehair` : '') + (description ? ` desc-shinehair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shinehair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shinehair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.61 18.44a.3.3 0 0 1 .56-.04l.02.04.48 1.49 1.42.5c.25.08.28.41.09.55l-.04.03-.05.02-1.42.5L4.19 23a.3.3 0 0 1-.54.09l-.02-.04-.02-.05-.48-1.48-1.42-.5a.32.32 0 0 1-.08-.56l.03-.02.05-.02 1.42-.5.48-1.49Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.23 8.88c.4-.04.78.25.82.67.48 4.33-.81 9.34-2.15 12.66a.75.75 0 1 1-1.39-.56c1.3-3.21 2.5-7.95 2.05-11.94a.75.75 0 0 1 .67-.83Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.92 5.13a.77.77 0 0 1 .57.38c.05.07.08.15.1.19l.1.32.1.4.14.46c.2.69.44 1.4.73 1.83.37.55.65.65.85.71l.36.1c.06 0 .11.02.17.04.22.08.46.23.65.49l.08.12.06.13c.05.14.07.26.08.34l.02.43a13.7 13.7 0 0 1-.85 4.11 7.87 7.87 0 0 1-2.38 3.44 24.88 24.88 0 0 0 .34 2.58l.07.22a.75.75 0 0 1-1.11 1 1.33 1.33 0 0 1-.28-.43 9.85 9.85 0 0 1-.32-1.4c-.06-.4-.1-.83-.14-1.21a4.73 4.73 0 0 1-2.9-.02c-.03.4-.07.84-.15 1.25-.06.36-.15.74-.28 1.06-.12.28-.33.7-.75.9a.75.75 0 0 1-.72-1.31 3.78 3.78 0 0 0 .28-.9c.1-.62.14-1.32.14-1.78a8.44 8.44 0 0 1-2.37-2.96c-.5-1-.85-2.06-1.03-2.98-.09-.46-.14-.9-.15-1.28 0-.38.03-.76.15-1.09l.05-.1c.13-.26.32-.43.51-.54.21-.12.44-.2.65-.24.42-.1.94-.14 1.42-.18.5-.04 1-.08 1.47-.16s.86-.19 1.14-.34a4.5 4.5 0 0 0 1.6-1.82l.26-.51.24-.46c.07-.13.16-.28.26-.4a.9.9 0 0 1 .74-.39h.1Zm-.32 2.53a5.9 5.9 0 0 1-2.15 2.36 5 5 0 0 1-1.63.51c-.54.1-1.1.13-1.6.17a8.93 8.93 0 0 0-1.36.2c-.02.09-.03.23-.03.43 0 .28.05.63.12 1.02.16.79.46 1.71.9 2.59.91 1.8 2.28 3.15 3.98 3.15 1.87 0 3.1-1.51 3.84-3.45a12.2 12.2 0 0 0 .76-3.58v-.12h-.04l-.3-.08a2.91 2.91 0 0 1-1.68-1.32 7.64 7.64 0 0 1-.81-1.88Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.32.78c1.85.03 3.4.37 4.7.97a.75.75 0 0 1-.62 1.36c-1.08-.5-2.43-.8-4.1-.83-2.26-.05-3.92.42-5.13 1.2a6.62 6.62 0 0 0-2.58 3.28c-1.08 2.77-.92 6.47-.21 9.92a.75.75 0 1 1-1.47.3c-.73-3.54-.96-7.59.28-10.77.63-1.6 1.64-3 3.16-3.99 1.52-.97 3.5-1.5 5.97-1.44Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.14 2.75a.38.38 0 0 1 .7-.06l.02.06.6 1.77 1.78.6c.3.11.34.5.1.68l-.04.02-.06.03-1.78.6-.6 1.78c-.1.3-.5.34-.67.1l-.03-.05-.02-.05-.6-1.78-1.78-.6a.38.38 0 0 1-.1-.67l.05-.03.05-.02 1.78-.6.6-1.78Z",
    fill: "#232323"
  }));
};
var _default = exports.default = shinehair;